/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const EntityShippingCreatePage = lazyLoad(
  () => import('./index'),
  module => module.EntityShippingCreatePage
);
